<template>
  <avue-crud
    :option="tableConfig"
    :data="basicInfoData.planList"
    v-model="tableForm"
    :page.sync="page"
    :summary-method="summaryMethod"
  >
    <template slot="isWriteoff" slot-scope="{ row }">
      <div>
        {{
          row.isWriteoff == 2
            ? "提前结清"
            : row.isWriteoff == 1
            ? "已结清"
            : row.isWriteoff == 0
            ? basicInfoData.prepayment.isWriteoff == 1
              ? "提前还款"
              : "待结清"
            : ""
        }}
      </div>
    </template>
  </avue-crud>
</template>

<script>
import { earnoutDetailListConfig } from "../config.js";
import * as api from "@/api/factoring/factoringScheme";
import util from "@/mixins/util";
import { floatAdd } from "@/util/util";
export default {
  name: "earnoutTable",
  mixins: [util],
  data() {
    return {
      page: {
        currentPage: 1,
        total: 0,
        layout: "total,pager,prev, next",
        background: false,
        pageSize: 10,
      },
      tableConfig: earnoutDetailListConfig(this.getMoney, this.dateConvert),
      tableForm: {},
      query: {},
      tableData: [],
      loading: false,
    };
  },
  props: {
    basicInfoData: {
      type: Object,
      default: () => {
        return { planList: [], prepayment: {} };
      },
    },
  },
  watch: {},

  components: {},

  methods: {
    summaryMethod({ columns, data }) {
      const sums = [];
      if (columns.length > 0) {
        columns.forEach((column, index) => {
          if ([0, 1, 6, 7].includes(index)) {
            sums[index] = "-";
          } else {
            let values = 0;
            data.map((item) => (values =floatAdd(values,Number(item[column.property])) ));
            sums[index] = this.getMoney(values.toFixed(2));
          }
        });
      }
      return sums;
    },
  },
};
</script>


<style lang="scss" scoped>
/deep/ .avue-crud__menu {
  min-height: 16px;
}

/deep/ .el-table__footer-wrapper tbody td {
  color: #409eff;
}
/deep/ .el-table__footer-wrapper .cell {
  height: 23px !important;
}
</style>